import Accordion from 'react-bootstrap/Accordion';

interface CustomAccordionType {
  item: {
    key: string;
    header: string;
  },
  children: React.ReactNode;
}

export default function CustomAccordion(props: CustomAccordionType) {
  const { item, children } = props;

  return (
    <Accordion alwaysOpen>
      <Accordion.Item eventKey={item.key}>
        <Accordion.Header>{item.header}</Accordion.Header>
        <Accordion.Body>
         {children}
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
}
